import { get, post } from '@/shared/utils/FetchV2.util';
import type { SyncStatusResponse } from './syncStatus.types';

export const getSyncStatus = async (): Promise<SyncStatusResponse> => {
  try {
    return await get<SyncStatusResponse>({
      service: 'fiscalEngine',
      endpoint: '/taxpayer/web/sync-status',
    });
  } catch (error: any) {
    if (error?.response?.status === 404) {
      return {
        sync_id: null,
        user_id: 0,
        started_at: null,
        last_updated_at: null,
        overall_progress: 0,
        has_useful_data: false,
        is_complete: false,
        detected_regime: null,
        waves: null,
        ui_groups: null,
        polling_hint: { should_stop: true, recommended_interval_ms: 0, reason: 'no_execution' },
      };
    }
    throw error;
  }
};

export const retrySyncExtractions = async (): Promise<{ retried: string[] }> => {
  return post({
    service: 'fiscalEngine',
    endpoint: '/taxpayer/web/sync-retry',
    body: {},
  });
};

export const getSyncRetryStatus = async (): Promise<{ extractions: { type: string; status: string }[]; all_done: boolean }> => {
  return get({
    service: 'fiscalEngine',
    endpoint: '/taxpayer/web/sync-retry/status',
  });
};
